<template>
  <div>
    <OnexAlert
      v-if="isShowMessage && selectedWithdrawalDay !== null"
      :type="Notifications.warning"
      :icon="mdiAlert"
      style="box-shadow: none !important"
    >
      {{ $t('L_please_be_advised_that_selecting_a_withdrawal') }}
    </OnexAlert>
    <div class="mt-4 pb-4" :class="$vuetify.display.xs ? 'pl-8' : 'px-8'">
      <div>
        <!--selectedWithdrawalDay: {{ selectedWithdrawalDay }} <BR />
      policydata.paynowInfo: {{ isPaidToDateInFuture }} <BR />
      selectedWithdrawalDay: {{ selectedWithdrawalDay }} <BR />
      selectedWithdrawalDay: {{ selectedWithdrawalDay() }} <BR />
      currentMonthDay: {{ currentMonthDay() }} <BR />
      currentMonth(): {{ currentMonth() }} <BR />
      newDraftDay() {{ newDraftDay() }} <BR />
      currentDraftDate() {{ currentDraftDate() }} <BR />
      currentDraftDateDay() {{ currentDraftDateDay() }} <BR />
      nextPaymentDueDate() {{ nextPaymentDueDate() }} <BR />
      nextPaymentDueMonth {{ nextPaymentDueMonth() }} <BR /> -->
        <!-- TEST <BR />
      TEST <BR />
      TEST <BR />
      TEST <BR />
      TEMP: selectedWithdrawalDay |{{ selectedWithdrawalDay }}|
      now {{ getMoment }}
      getMomentTwoDaysAway {{ getMomentTwoDaysAway }}
      date with user selected day {{ getMomentDayWithUserSelectedDay }}
      isUserSelectedDateLaterThanTwoDaysAway {{ isUserSelectedDateLaterThanTwoDaysAway }}
      userSelectedDayWithCurrentMonthYear.date(this.selectedWithdrawalDay): {{ userSelectedDayWithCurrentMonthYear.date(this.selectedWithdrawalDay) }} -->
        <!-- moment().add(2, 'days'): {{ moment().add(2, 'days') }} -->
      </div>
      <v-row wrap>
        <v-col cols="12">
          <div>
            <v-row wrap class="mt-4 mb-4">
              <v-col cols="12" class="font-size--16">
                {{ $t('L_select_a_preferred_withdrawal_date_for_your') }}
              </v-col>
              <v-col cols="12">
                <span>
                  <OnexSelect
                    variant="filled"
                    :items="getDateOptions"
                    v-model="selectedWithdrawalDay"
                    :label="$t('L_Withdrawal_date')"
                    class="selectMaxWidth"
                    :menu-props="{
                      maxHeight: '272px',
                      location: 'bottom center',
                      scrollStrategy: 'close',
                    }"
                    color="black"
                  />
                </span>
              </v-col>
            </v-row>
            <v-row class="d-flex justify-end my-4">
              <v-col cols="12" sm="4" md="3" class="px-4">
                <OnexButton block variant="outlined" color="outlined" @click="$emit('cancel')">
                  {{ $t('L_cancel') }}
                </OnexButton>
              </v-col>
              <v-col cols="12" sm="4" md="3" class="px-4">
                <OnexButton block :disabled="badForm" @click="goToStepFourBankDraft">
                  {{ $t('L_continue') }}
                </OnexButton>
              </v-col>
            </v-row>
          </div>
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, type ComponentOptions } from 'vue';
import { formatDate } from '@/shared/util/formatters';
import { mapState, mapActions } from 'pinia';
import { set, addDays, compareAsc } from 'date-fns';
import { usePolicyStore } from '@/modules/policy/store/policy.store';
import { useGlobalStore } from '@/stores/global/global.store';
import { Notifications, OnexAlert, OnexSelect, OnexButton } from '@primerica/onex-ui-lib';
import { mdiAlert } from '@mdi/js';
const componentOptions: ComponentOptions = {
  name: 'PayMethodChangeStepThree',
  components: {
    OnexSelect,
    OnexAlert,
    OnexButton,
  },
  data: () => ({
    selectedWithdrawalDay: null as string | number | null,
    processCompleted: false,
    persistent: true,
    mdiAlert,
    Notifications,
  }),
  props: {
    wDay: {
      type: String,
      default: '-1',
      required: false,
    },
    // existingBankInfo: {
    //   type: Object,
    //   required: true,
    // },
  },
  watch: {
    // TODO
    wDay(value) {
      if (value.length === 2 && value.substr(0, 1) === '0') {
        this.selectedWithdrawalDay = value.substr(1, 1);
      } else {
        this.selectedWithdrawalDay = value;
      }
    },
  },
  computed: {
    ...mapState(useGlobalStore, {
      locale: 'getLocale',
      dateFormat: 'getDateFormat',
    }),
    ...mapState(usePolicyStore, {
      policyData: 'currentPolicy',
    }),
    isPaidToDateInFuture() {
      return this.policyData?.paynowInfo?.isPTDFuture || false;
    },
    getDraftAmount() {
      return this.policyData?.paymentInfo?.PACPremium || '';
    },
    isUserSelDateEarlierThanTwoDaysFromNow() {
      const today = new Date();
      const selectedDay = Number(this.selectedWithdrawalDay);
      if (!Number.isFinite(selectedDay)) {
        return false;
      }

      const selectedWithdrawalDayDate = set(today, { date: selectedDay });
      const threshold = addDays(today, 3);

      return compareAsc(selectedWithdrawalDayDate, threshold) <= 0;
    },
    isShowMessage() {
      const isPastDue = this.policyData?.paynowInfo?.isPastDue || false;
      // isPaidToDateInFuture()    return this.policyData?.paynowInfo?.IsPTDFuture || false;
      // isUserSelDateEarlierThanTwoDaysFromNow() {
      //   const today = new Date();
      //   const selectedWithdrawalDayDate = startOfDay(
      //     set(today, { date: this.selectedWithdrawalDay })
      //   );
      //   const threshold = startOfDay(addDays(today, 3));
      //   return compareAsc(selectedWithdrawalDayDate, threshold) <= 0;
      // },
      if (
        isPastDue === false &&
        this.isPaidToDateInFuture === false &&
        this.isUserSelDateEarlierThanTwoDaysFromNow
      ) {
        return true;
      } else if (isPastDue === true && this.isUserSelDateEarlierThanTwoDaysFromNow) {
        return true;
      }
      return false;
    },
    getDateOptions() {
      const dateOptions = [
        // { value: -1, title: ' ' },
        { value: 1, title: '1st' },
        { value: 2, title: '2nd' },
        { value: 3, title: '3rd' },
        { value: 4, title: '4th' },
        { value: 5, title: '5th' },
        { value: 6, title: '6th' },
        { value: 7, title: '7th' },
        { value: 8, title: '8th' },
        { value: 9, title: '9th' },
        { value: 10, title: '10th' },
        { value: 11, title: '11th' },
        { value: 12, title: '12th' },
        { value: 13, title: '13th' },
        { value: 14, title: '14th' },
        { value: 15, title: '15th' },
        { value: 16, title: '16th' },
        { value: 17, title: '17th' },
        { value: 18, title: '18th' },
        { value: 19, title: '19th' },
        { value: 20, title: '20th' },
        { value: 21, title: '21st' },
        { value: 22, title: '22nd' },
        { value: 23, title: '23rd' },
        { value: 24, title: '24th' },
        { value: 25, title: '25th' },
        { value: 26, title: '26th' },
        { value: 27, title: '27th' },
        { value: 28, title: '28th' },
      ];
      return dateOptions;
    },
    badForm() {
      return this.selectedWithdrawalDay === -1;
    },
  },
  methods: {
    ...mapActions(useGlobalStore, {
      removeAlerts: 'removeAlerts',
    }),
    goToStepFourBankDraft() {
      let tWithdrawalVal = this.selectedWithdrawalDay + '';
      if (tWithdrawalVal.length === 1) {
        tWithdrawalVal = `0${tWithdrawalVal}`;
      }
      this.$emit(
        'isUserSelDateEarlierThanTwoDaysFromNow',
        this.isUserSelDateEarlierThanTwoDaysFromNow
      );
      this.$emit('isPastDue', this.policyData?.paynowInfo?.isPastDue || false);
      this.$emit('isPaidToDateInFuture', this.isPaidToDateInFuture);
      this.$emit('goToStepFourBankDraft', tWithdrawalVal);
    },
  },
  async mounted() {
    this.processCompleted = false;
    // set withdrawal day
    await this.removeAlerts('payment');
    this.processCompleted = true;
  },
};
export default defineComponent(componentOptions);
</script>

<style lang="scss" scoped>
.selectMaxWidth {
  max-width: 320px;
  width: 100%;
  padding-bottom: 4px !important;
}

.valid-bank.v-text-field > .v-input__control > .v-input__slot:before {
  display: none !important;
}

.valid-bank.v-text-field > .v-input__control > .v-input__slot:after {
  display: none !important;
}
</style>
